import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

import { computed } from "vue";
  import { useStore } from "vuex";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'render-content-page',
  setup(__props) {

  const store = useStore();
  
  const contentPage = computed(() => store.state.gon.content_page)
  const contentItems = computed(() => {
    return ((contentPage.value || {}).content_items || []).sort(
      (a: any, b: any) => a.position - b.position,
    );
  });
  const styleObject = computed(() => {
    const styles: Record<string, string> = {};

    if (contentPage.value.page_width)
      styles["max-width"] = contentPage.value.page_width + "px";

    if (contentPage.value.plain_style) styles["margin"] = "auto";

    return styles;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "components__render-content-page",
    style: _normalizeStyle(styleObject.value)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contentItems.value, (contentItem) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "render-widget",
        key: contentItem.position
      }, [
        (contentItem.widget_config.backend)
          ? _renderSlot(_ctx.$slots, `slot-${contentItem.id}`, { key: 0 }, () => [
              _createElementVNode("pre", null, _toDisplayString(contentItem), 1)
            ])
          : (_openBlock(), _createBlock(_resolveDynamicComponent(contentItem.widget_type), {
              key: 1,
              "content-item": contentItem
            }, null, 8, ["content-item"]))
      ]))
    }), 128))
  ], 4))
}
}

})